import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import StaffGrid from "./StaffGrid";

export default function StaffMenu({onClose}:{onClose: () => void}) {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex flex-row items-center px-6">
        <NavLink to={"/data/staff"} onClick={onClose}><div className="text-base font-semibold flex h-14 items-center">{t("staff")}</div></NavLink>
      </div>
      <StaffGrid onClose={onClose}/>
    </>
  )
} 